import type { GroundingSourceRecord } from "@/types/grounding";

export type RationaleEvidenceDetailMode = "less" | "more";

export const RATIONALE_EVIDENCE_DETAIL_STORAGE_KEY = "JENLY_RATIONALE_EVIDENCE_DETAIL_MODE";
export const RATIONALE_EVIDENCE_DETAIL_CHANGED_EVENT = "jenly:rationale-evidence-detail-changed";

const LESS_DETAIL_FILE_EXTENSIONS = new Set(["docx", "pdf", "txt", "md", "png", "csv", "pptx", "xlsx"]);

export const isRationaleEvidenceDetailMode = (value: unknown): value is RationaleEvidenceDetailMode =>
  value === "less" || value === "more";

export const getStoredRationaleEvidenceDetailMode = (
  defaultMode: RationaleEvidenceDetailMode = "more"
): RationaleEvidenceDetailMode => {
  try {
    const stored = window.localStorage.getItem(RATIONALE_EVIDENCE_DETAIL_STORAGE_KEY);
    return isRationaleEvidenceDetailMode(stored) ? stored : defaultMode;
  } catch {
    return defaultMode;
  }
};

export const setStoredRationaleEvidenceDetailMode = (mode: RationaleEvidenceDetailMode) => {
  try {
    window.localStorage.setItem(RATIONALE_EVIDENCE_DETAIL_STORAGE_KEY, mode);
    window.dispatchEvent(
      new CustomEvent<RationaleEvidenceDetailMode>(RATIONALE_EVIDENCE_DETAIL_CHANGED_EVENT, { detail: mode })
    );
  } catch {
    window.dispatchEvent(
      new CustomEvent<RationaleEvidenceDetailMode>(RATIONALE_EVIDENCE_DETAIL_CHANGED_EVENT, { detail: mode })
    );
  }
};

export const getSourceFileExtension = (source: GroundingSourceRecord) => {
  const declaredType = typeof source.file_type === "string" ? source.file_type.trim().replace(/^\./, "") : "";
  if (declaredType) return declaredType.toLowerCase();

  const sourceName = source.source || "";
  const cleanName = sourceName.split(/[?#]/)[0].trim();
  const filename = cleanName.split(/[\\/]/).pop() || cleanName;
  const match = filename.match(/\.([a-z0-9]+)$/i);
  return match ? match[1].toLowerCase() : "";
};

export const shouldShowSourceInLessRationaleDetail = (source: GroundingSourceRecord) =>
  LESS_DETAIL_FILE_EXTENSIONS.has(getSourceFileExtension(source));
